import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const jadwaConfigSelector = ({ jadwaConfig }: ReducerState) => jadwaConfig;
export const jadwaConfigLoadingSelector = createSelector(
  jadwaConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
